import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import './styles/loader.css';

const Loader = ({ onLoadingComplete }) => {
    const hammerRef = useRef(null);
    const anvilRef = useRef(null);
    const sparksRef = useRef([]);
    const textRef = useRef(null);
    const progressRef = useRef(null);
    const containerRef = useRef(null);

    useEffect(() => {
        // Timeline principale GSAP
        const tl = gsap.timeline({
            onComplete: () => {
                // Animation de sortie
                gsap.to(containerRef.current, {
                    opacity: 0,
                    scale: 0.8,
                    duration: 0.5,
                    ease: "power2.inOut",
                    onComplete: onLoadingComplete
                });
            }
        });

        // Animation du marteau qui frappe
        tl.to(hammerRef.current, {
            rotation: -45,
            transformOrigin: "bottom center",
            duration: 0.6,
            ease: "power2.in",
            repeat: 3,
            yoyo: true,
            onRepeat: () => {
                // Animation de l'enclume au moment de l'impact
                gsap.to(anvilRef.current, {
                    scaleY: 0.9,
                    duration: 0.1,
                    yoyo: true,
                    repeat: 1
                });

                // Création d'étincelles
                sparksRef.current.forEach((spark, i) => {
                    gsap.fromTo(spark,
                        { 
                            x: 0, 
                            y: 0, 
                            opacity: 1, 
                            scale: 1 
                        },
                        {
                            x: gsap.utils.random(-100, 100),
                            y: gsap.utils.random(-100, -30),
                            opacity: 0,
                            scale: 0,
                            duration: 0.6,
                            delay: i * 0.02,
                            ease: "power2.out"
                        }
                    );
                });
            }
        });

        // Animation du texte "Forgeron Numérique"
        const chars = textRef.current.querySelectorAll('.char');
        tl.fromTo(chars, 
            { 
                y: 30, 
                opacity: 0 
            },
            {
                y: 0,
                opacity: 1,
                stagger: 0.05,
                duration: 0.3,
                ease: "back.out(1.7)"
            }, 
            "-=2"
        );

        // Animation de la barre de progression
        tl.to(progressRef.current, {
            width: "100%",
            duration: 2.5,
            ease: "power1.inOut"
        }, "-=2.5");

        return () => {
            tl.kill();
        };
    }, [onLoadingComplete]);

    return (
        <div ref={containerRef} className="loader-container">
            <div className="forge-animation">
                {/* Enclume */}
                <div ref={anvilRef} className="anvil">
                    <div className="anvil-top"></div>
                    <div className="anvil-base"></div>
                </div>

                {/* Marteau */}
                <div ref={hammerRef} className="hammer">
                    <div className="hammer-handle"></div>
                    <div className="hammer-head"></div>
                </div>

                {/* Étincelles */}
                <div className="sparks">
                    {[...Array(12)].map((_, i) => (
                        <span 
                            key={i} 
                            ref={el => sparksRef.current[i] = el}
                            className="spark"
                        ></span>
                    ))}
                </div>
            </div>

            {/* Texte animé */}
            <div ref={textRef} className="loader-text">
                {'Forgeron.Numérique'.split('').map((char, index) => (
                    <span key={index} className="char">
                        {char}
                    </span>
                ))}
            </div>

            {/* Barre de progression */}
            <div className="progress-container">
                <div ref={progressRef} className="progress-bar"></div>
            </div>

            {/* Texte de chargement */}
            <p className="loading-text">Forge en cours...</p>
        </div>
    );
};

export default Loader;
